// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const MeetingsList    = lazy(() => import('../../views/meetings/list'))

const Meetings = [
  {
    path: '/meetings/list',
    element: <MeetingsList />
  }
]

export default Meetings
